import { render, staticRenderFns } from "./ProgramsHighlight.vue?vue&type=template&id=1a4cd738"
import script from "./ProgramsHighlight.vue?vue&type=script&lang=js"
export * from "./ProgramsHighlight.vue?vue&type=script&lang=js"
import style0 from "./ProgramsHighlight.vue?vue&type=style&index=0&id=1a4cd738&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports